export const tooltipLayoutByVariant = {
  article: {
    content: 'ActivityModal.Theory.content',
    titleText: 'ActivityModal.Theory.titleText',
  },
  card_form_activity: {
    content: 'ActivityModal.CardForm.content',
    titleText: 'ActivityModal.CardForm.titleText',
  },
  choose_correct_side_activity: {
    content: 'ActivityModal.ChoosingSide.content',
    subtitleText: 'ActivityModal.ChoosingSide.subtitleText',
    titleText: 'ActivityModal.ChoosingSide.titleText',
  },
  match_activity: {
    content: 'ActivityModal.PerfectMatch.content',
    subtitleText: 'ActivityModal.PerfectMatch.subtitleText',
    titleText: 'ActivityModal.PerfectMatch.titleText',
  },
  reward: {
    content: 'ActivityModal.Reward.content',
    titleText: 'ActivityModal.Reward.titleText',
  },
  scenario: {
    content: 'ActivityModal.Scenarios.content',
    titleText: 'ActivityModal.Scenarios.titleText',
  },
  situation: {
    content: 'ActivityModal.SituationIllustration.content',
    titleText: 'ActivityModal.SituationIllustration.titleText',
  },
  sorting_activity: {
    content: 'ActivityModal.Sorting.content',
    titleText: 'ActivityModal.Sorting.titleText',
  },
  test: {
    content: 'ActivityModal.Test.content',
    subtitleText: 'ActivityModal.Test.subtitleText',
    titleText: 'ActivityModal.Test.titleText',
  },
  theory: {
    content: 'ActivityModal.Theory.content',
    titleText: 'ActivityModal.Theory.titleText',
  },
};
